import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

import { IFilters } from 'app/models/filter.models';

import { environment } from 'environments/environment';
import { OperationsResponse } from 'app/models/operations.models';

@Injectable({
  providedIn: 'root',
})
export class OperationsService {
  constructor(private http: HttpClient) {}

  getOperations(filters: IFilters, params: HttpParams): Observable<OperationsResponse> {
    return this.http
      .post<OperationsResponse>(
        `${environment.apiUrl}/api/analytics/operations`,
        {
          ...filters,
        },
        {
          params,
        },
      )
      .pipe(
        catchError(() => {
          return of();
        }),
      );
  }

  exportAll(filters: IFilters, params: HttpParams, displayedColumns: string[]) {
    return this.http
      .post(
        `${environment.apiUrl}/api/analytics/operations/export/csv`,
        {
          filters,
          fields: displayedColumns,
        },
        { responseType: 'text', params },
      )
      .pipe(
        catchError(() => {
          return of();
        }),
      );
  }
}
